import { render } from "./FoodMenus.vue?vue&type=template&id=1850c7d6&scoped=true&ts=true"
import script from "./FoodMenus.vue?vue&type=script&lang=ts"
export * from "./FoodMenus.vue?vue&type=script&lang=ts"

import "./FoodMenus.vue?vue&type=style&index=0&id=1850c7d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1850c7d6"]])

export default __exports__